<template>
  <div
    v-expose-track="{
      coupon_center: {
        mapId: 'couponExposure',
        data: {
          spm: $trackMap.couponCenter.couponExposure,
          ...getTracerParams()
        }
      }
    }"
    class="coupon"
    :class="{ outsale: outSale }"
  >
    <img v-if="couponTag" class="tag_pop" :src="couponTag" />

    <div class="left">
      <div class="facevalue" :class="{ long: longValue }">
        ￥<span>{{ coupon.faceValue }}</span>
      </div>
      <div class="condition">{{ coupon.thresholdDesc }}</div>
    </div>
    <div class="right">
      <div class="name">{{ coupon.name }}</div>
      <div class="info">{{ coupon.description }}</div>
      <div v-if="!canReceive" class="desc">
        {{ coupon.effectiveDesc }}
      </div>
      <div v-if="canReceive" class="progress">
        <div class="value" :style="{ width: `${remainPercent}%` }"></div>
        <div class="text">剩余{{ remainPercent }}%</div>
      </div>
      <div v-if="isPop" class="shoplink" @click="goShop">
        进店<maple-icon
          class="arrow"
          name="right_outlined"
          color="#999"
          size="0.24rem"
        />
      </div>
      <img
        v-if="canUse || notInDate"
        class="statusimg"
        src="@/images/coupon_center/received.png"
      />
      <img
        v-if="outSale"
        class="statusimg"
        src="@/images/coupon_center/outsale.png"
      />
      <van-button
        v-if="canReceive || canUse"
        class="btn"
        type="primary"
        size="small"
        :color="canUse ? '#F45E33' : 'linear-gradient(90deg, #F45E33, #FF5030)'"
        round
        :hollow="canUse"
        @click="handleBtn"
      >
        {{ canReceive ? '立即领取' : '去使用' }}
      </van-button>
    </div>
  </div>
</template>

<script>
// import { API } from '@/api'
import mixin from '../mixin'
export default {
  mixins: [mixin],
  computed: {
    longValue() {
      return this.coupon.faceValue > 999
    },
    // 剩余量百分比
    remainPercent() {
      const { remain, amount } = this.coupon
      return Math.floor((remain / amount) * 100)
    }
  },
  methods: {
    receiveTracer() {
      const parmas = this.getTracerParams()
      this.$track(this.$trackMap.couponCenter.receive, parmas)
    },
    goUseTracer() {
      const parmas = this.getTracerParams()
      this.$track(this.$trackMap.couponCenter.use, parmas)
    },
    goShop() {
      this.$track(this.$trackMap.couponCenter.goPop, {
        pop_id: Number(this.coupon.popId) || 0,
        str_coupon_id: String(this.coupon.modelId) || '',
        coupon_state: String(this.coupon.couponStatus) || '',
        coupon_pos: String(this.index) || ''
      })
      this.$autoRedirect(this.coupon.shopUrl)
    },
    getTracerParams() {
      return {
        str_coupon_id: String(this.coupon.modelId) || '',
        is_pop_coupon: String(this.coupon.isShopCoupon) || '',
        coupon_pos: String(this.index) || '',
        coupon_state: String(this.couponStatus)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.coupon {
  display: flex;

  position: relative;

  height: 2.08rem;
  .tag_pop {
    position: absolute;
    top: 0.12rem;
    left: -0.04rem;

    width: 0.76rem;
  }
  .left {
    display: flex;

    width: 1.86rem;

    background-image: radial-gradient(
      circle at 1.86rem 0.1rem,
      transparent 0,
      transparent 0.1rem,
      #fff0ec 0.1rem
    );

    flex: none;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    text-align: center;

    color: #ff3900;
    border-top-left-radius: 0.16rem;
    border-bottom-left-radius: 0.16rem;
    background-position-y: -0.1rem;
    .facevalue {
      font-size: 0.4rem;
      font-weight: 800;
      & > span {
        margin-left: 0.04rem;

        font-size: 0.72rem;
      }
      &.long {
        & > span {
          font-size: 0.56rem;
        }
      }
    }
    .condition {
      margin-top: 0.1rem;

      font-size: 0.28rem;
    }
  }
  .right {
    position: relative;

    width: 0;
    padding-right: 0.3rem;
    padding-left: 0.4rem;
    overflow: hidden;

    background-image: radial-gradient(
      circle at 0 0.1rem,
      transparent 0,
      transparent 0.1rem,
      #fff 0.1rem
    );

    flex: auto;

    border-top-right-radius: 0.16rem;
    border-bottom-right-radius: 0.16rem;
    background-position-y: -0.1rem;

    .name {
      position: relative;
      z-index: 2;

      margin-top: 0.24rem;
      margin-right: 1rem;
      overflow: hidden;

      font-size: 0.32rem;
      line-height: 0.4rem;
      font-weight: 800;
      white-space: nowrap;
      color: #262626;
      text-overflow: ellipsis;
    }

    .info {
      position: relative;
      z-index: 2;

      margin-top: 0.17rem;
      overflow: hidden;

      font-size: 0.28rem;
      line-height: 0.34rem;
      white-space: nowrap;
      color: #999;
      text-overflow: ellipsis;
    }

    .desc {
      margin-top: 0.38rem;

      font-size: 0.24rem;
      color: #999;
    }
    .progress {
      position: relative;

      width: 2rem;
      height: 0.24rem;
      margin-top: 0.38rem;

      background-color: #ffc4b3;
      border-radius: 0.16rem;
      .value {
        height: 0.24rem;

        background-image: linear-gradient(90deg, #ff8e6e, #ff5030);
        border-radius: 0.16rem;
      }
      .text {
        position: absolute;
        top: 0;
        left: 0.12rem;

        font-size: 0.2rem;
        line-height: 0.24rem;
        color: #fff;
      }
    }
    .shoplink {
      position: absolute;
      top: 0.28rem;
      right: 0.2rem;
      z-index: 1;

      font-size: 0.28rem;
      color: #999;
      .arrow {
        margin-left: 0.04rem;

        font-weight: 800;
      }
    }
    .statusimg {
      position: absolute;
      top: -0.24rem;
      right: 0.04rem;

      width: 1.2rem;
      height: 1.2rem;
    }
    .btn {
      position: absolute;
      right: 0.24rem;
      bottom: 0.28rem;

      width: 1.44rem;
      height: 0.48rem;
    }
  }
  &.outsale {
    .left {
      background-image: radial-gradient(
        circle at 1.86rem 0.1rem,
        transparent 0,
        transparent 0.1rem,
        #e1e1e1 0.1rem
      );

      color: #fff;
    }
  }
}
</style>
